import * as React from 'react';

import styled from 'styled-components';

import { AnimatePresence } from 'framer-motion';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CircleCheckIcon from '@components/basics/icons/circle-check';
import SquareImg from '@components/basics/artwork-img';
import MotionOpacity from '@components/motion/motion-opacity';
import UnselectedIcon from '@components/basics/icons/unselected';

export interface RadioSelectProps {
  className?: string;
  children?: any;
  isChecked?: boolean;
  hasArtwork?: boolean;
  isAlbum?: boolean;
  albumTrack?: boolean;
  artwork?: string;
  onChange: (active: boolean) => void;
}

export const RadioSelect: React.FC<RadioSelectProps> = (props) => {
  const handleClick = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    ev.stopPropagation();
    props.onChange(!props.isChecked);
  };

  return (
    <Flex
      className={`${props.className} ${props.albumTrack ? 'album-track' : ''} ${
        props.isChecked ? 'is-checked' : ''
      }`}
      justifyContent="space-between"
      alignItems="center"
      onClick={(ev: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
        handleClick(ev)
      }
    >
      <Flex justifyContent="flex-start" alignItems="center">
        {props.hasArtwork && !props.albumTrack ? (
          <SquareImg className="artwork" srcImg={props.artwork} size={32} />
        ) : null}
        <Typography className="item-text" weight="700">
          {props.children}
        </Typography>
      </Flex>
      {props.isAlbum ? null : (
        <AnimatePresence>
          {props.isChecked ? (
            <MotionOpacity className="wrapper-icon">
              <CircleCheckIcon
                className="icon-check"
                iconSize={24}
                noAnimation
              />
            </MotionOpacity>
          ) : (
            <MotionOpacity className="wrapper-icon">
              <UnselectedIcon className="icon-check" iconSize={24} />
            </MotionOpacity>
          )}
        </AnimatePresence>
      )}
    </Flex>
  );
};

export default styled(RadioSelect)`
  cursor: ${(props) => (props.isAlbum ? 'auto' : 'pointer')};
  min-height: 24px;

  ${(props) => (props.isChecked ? null : 'opacity: .5')};

  &.is-checked {
    opacity: 1;
  }

  &.album-track {
    margin-left: 48px;
  }

  .artwork {
    margin-right: 16px;
  }

  .wrapper-icon {
    display: flex;
  }

  .icon-check {
    cursor: pointer;
  }

  .item-text {
    user-select: none;
  }
`;
